<template>
  <form @submit.prevent="save" class="ortic-form-horizontal">
    <o-card>
      <b-tabs class="inline-tabs" ref="tabs" v-model="activeTab">
        <b-tab :title="$t('sandoz.kuko_request_info')" active>

          <b-alert show variant="warning" v-if="item.approval_feedback">{{item.approval_feedback_user.name}}: {{item.approval_feedback}}</b-alert>

          <b-row>
            <b-col>
              <o-value-select :readonly="readOnly || !isNew" :label="$t('sandoz.requestor')" url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&per_page=99999&include=regions" value-field="id" text-field="name" v-model="item.user_id" @input-object="setCurrentUser"></o-value-select>
            </b-col>
            <b-col>
              <o-datepicker :readonly="true" :disabled="true" :label="$t('sandoz.request_date')" v-model="item.kuko_date"/>
            </b-col>
            <b-col>
              <o-form-group :label="$t('sandoz.kuko_type')">
                <div>
                  <b-form-radio v-model="item.kuko_type" :disabled="readOnly" name="kuko_type" value="condition">{{$t('sandoz.conditions')}}</b-form-radio>
                  <b-form-radio v-model="item.kuko_type" :disabled="readOnly" name="kuko_type" value="payment_terms">{{$t('sandoz.payment_terms')}}</b-form-radio>
                  <b-form-radio v-model="item.kuko_type" :disabled="readOnly" name="kuko_type" value="chargebacks">{{$t('sandoz.chargebacks')}}</b-form-radio>
                </div>
              </o-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <o-value-select v-model="item.kuko_year" :items="years" :label="$t('sandoz.kuko_year')"
                :title="$t('sandoz.kuko_year')" @input-object="checkConditionYear"/>
            </b-col>
            <b-col>
              <o-input :label="$t('sandoz.status')" :value="statusLabel" readonly/>
            </b-col>
            <b-col></b-col>
          </b-row>
          <b-form-group :label="$t('sandoz.account_category')" class="mt-3">
            <div class="align-category">
            <b-form-radio v-model="item.account_category" v-if="hasAccountCategory('individual_account', 'Individual Account')" :disabled="readOnly" name="account_category" value="individual_account">{{$t('sandoz.individual_account')}}</b-form-radio>
            <b-form-radio v-model="item.account_category" v-if="item.kuko_type != 'payment_terms' && hasAccountCategory('buying_group', 'Buying Group')" :disabled="readOnly" name="account_category" value="buying_group">{{$t('sandoz.buying_group')}}</b-form-radio>
            <b-form-radio v-model="item.account_category" v-if="item.kuko_type != 'payment_terms' && hasAccountCategory('smart_selection', 'Special Customer Selection')" :disabled="readOnly" name="account_category" value="smart_selection">{{$t('sandoz.smart_selection')}}</b-form-radio>
            <!-- <b-form-radio v-model="item.account_category" v-if="item.kuko_type != 'payment_terms' && hasAccountCategory('chargeback_condition', 'Chargeback Conditions (new)')" :disabled="readOnly" name="account_category" value="chargeback_condition">{{$t('sandoz.chargeback_condition')}}</b-form-radio> -->
            </div>
          </b-form-group>
          <hr>
          
          <o-form-group :label="$t('sandoz.approvers')">
            <div class="w-100">
              <div class="mb-1">
                <b-row>
                  <b-col class="mw-242">
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="APO">APO</b-form-radio>
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="SD">SD</b-form-radio>
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="HOSP">HOSP</b-form-radio>
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="IMMUNO">IMMUNO</b-form-radio>
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="High Specialty">
                      High Specialty
                    </b-form-radio>
                    <template v-if="item.legacy_kuko">
                      <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="KAM">KAM</b-form-radio>
                    </template>
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="Wholesaler">Wholesaler</b-form-radio>
                    <b-form-radio v-model="item.channel" :disabled="readOnly" name="channel" value="Market Access">
                      Market Access
                    </b-form-radio>
                  </b-col>
                  <b-col class="mw-242">
                    <b-form-checkbox :disabled="true" v-if="item.channel === 'Market Access'" v-model="trueValue">
                      Head of Market Access
                    </b-form-checkbox>
                    <b-form-checkbox :disabled="true" v-model="trueValue">CFO</b-form-checkbox>
                    <b-form-checkbox :disabled="true" v-model="trueValue">Customer Service</b-form-checkbox>
                    <b-form-checkbox :disabled="true" v-model="trueValue">Customer Service (4th eye)</b-form-checkbox>
                  </b-col>
                </b-row>
              </div>

              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>{{$t('sandoz.approval_role')}}</th>
                    <th v-if="['Committed', 'Approved', 'Feedback', 'Stored', 'Contract Approval Pending'].includes(item.status)">{{$t('sandoz.approver')}}</th>
                    <th v-if="['Committed', 'Approved', 'Feedback', 'Stored', 'Contract Approval Pending'].includes(item.status)">{{$t('sandoz.approval_date')}}</th>
                    <th>{{$t('sandoz.allowed_approvers')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(approvalStep, approvalStepIndex) in item.approval_steps" :key="approvalStepIndex">
                    <td>
                      {{approvalStep.approval_role}}
                    </td>
                    <td v-if="['Committed', 'Approved', 'Feedback', 'Stored', 'Contract Approval Pending'].includes(item.status)">
                      <template v-if="approvalStep.approval_date">
                        {{approvalStep.user.name}}
                      </template>
                    </td>
                    <td v-if="['Committed', 'Approved', 'Feedback', 'Stored', 'Contract Approval Pending'].includes(item.status)">
                      <template v-if="approvalStep.approval_date">
                        ✓ {{approvalStep.approval_date | formatDate}}
                      </template>
                    </td>
                    <td>
                      <template v-if="item.account_category">
                        {{approvalStep.users.filter(u => u.enabled && u.user && (item.status !== 'Draft' || u.user.active)).filter(u => !u.is_deputy).map(u => u.user.name + (u.approval_role_type ? ' ('+u.approval_role_type+')' : '')).join(', ')}}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </o-form-group>

          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.kuko_customer_information')">
          <b-row v-if="item.account_category == 'individual_account'">
            <b-col>
              <o-form-group :label="$t('sandoz.customer_external_id')" class="mb-2">
                  <b-input-group>
                      <input v-model="item.external_id" type="text" class="form-control" disabled>
                      <b-input-group-append>
                          <b-btn variant="primary" @click.prevent="setIndividualAddress" v-if="!readOnly">
                            <fa icon="ellipsis-h"/>
                          </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </o-form-group>

              <o-input :label="$t('sandoz.company')" v-model="item.address1" readonly/>
              <o-input :label="$t('sandoz.street')" v-model="item.address2" readonly/>
              <o-input :label="$t('sandoz.zip_city')" v-model="item.address3" readonly/>
            </b-col>
            <b-col>
              <o-input :label="$t('sandoz.sap_id')" v-model="item.sap_id" readonly/>
              <o-input :label="$t('sandoz.account_sub_type')" v-model="item.account_sub_type" readonly/>
              <o-input :label="$t('sandoz.primary_parent')" v-model="item.primary_parent" readonly/>

              <div class="form-group">
                <label>{{ $t('sandoz.new_opening') }} <span class="text-danger" v-if="isNewOpeningRequired">*</span></label>
                <select class="custom-select" :disabled="readOnly" v-model="item.new_opening">
                  <option :value="null"></option>
                  <option :value="true">{{ $t('sandoz.yes') }}</option>
                  <option :value="false">{{ $t('sandoz.no') }}</option>
                </select>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="item.account_category == 'buying_group'">
            <b-col>
              <o-value-select @input-object="buyingGroupSelected" :readonly="readOnly" :label="$t('sandoz.buying_group')" url="/api/kukos/buying_groups" value-field="buying_group_code" text-field="buying_group" v-model="item.external_id"></o-value-select>
            </b-col>
            <b-col>
              <div class="text-danger mt-2" v-if="buyingGroupWarning">{{buyingGroupWarning}}</div>
            </b-col>
          </b-row>

          <b-row v-if="item.account_category == 'chargeback_condition'">
            <b-col>
              <div class="form-group">
                <label>{{  $t('sandoz.kuko_conditions') }}</label>
                <select class="custom-select" :disabled="readOnly" v-model="item.external_id" @change="conditionGroupSelected()">
                  <option v-for="group in conditionGroups" v-bind:key="group.value" v-bind:value="group.value" >{{group.text}}</option>
                </select>
              </div>
            </b-col>
            <b-col>
            </b-col>
          </b-row>

          <b-row v-if="item.account_category == 'smart_selection'">
            <b-col>
              <address-selection
                :readonly="readOnly"
                class="mb-3"
                v-model="item.smart_selection_conditions"
                @search-customers="searchCustomers"
                :dimensions="addressSelectionDimensions"
                :right-text="$tc('sandoz.customer_search_count', item.customers.length, {count: item.customers.length})"
                url="/api/kukos/smart-selection-dimensions"
                ></address-selection>

              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>{{$t('sandoz.customer_external_id')}}</th>
                    <th>{{$t('sandoz.name')}}</th>
                    <th>{{$t('sandoz.street')}}</th>
                    <th>{{$t('sandoz.zip_city')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="customer in filteredCustomers" :key="customer.external_id">
                    <td>{{customer.external_id}}</td>
                    <td>{{customer.name}}</td>
                    <td>{{customer.street}}</td>
                    <td>{{customer.zip_code}} {{customer.city}}</td>
                  </tr>
                  <tr>
                    <td colspan="4" v-if="filteredCustomers.length == 0" class="py-3">{{$t('sandoz.smart_selection_no_result')}}</td>
                  </tr>
                </tbody>
              </table>

              <b-btn v-if="maximumCustomers < item.customers.length" @click="maximumCustomers+=50" class="mb-3">
                {{$t('sandoz.show_more')}}
              </b-btn>

            </b-col>
          </b-row>

          <hr v-if="linkContracts.length > 0 && item.account_category">
          <b-row v-if="linkContracts.length > 0" class="mb-2">
            <b-col>
              <o-form-group :label="$t('sandoz.linked_contracts')" class="mb-2">
              </o-form-group>

              <div v-for="contract in filteredLinkContracts" :key="contract.id" class="mb-1">
                {{  contract.contract_no }}
                <span v-if="contract.status" class="ml-1 badge badge-info">
                  {{ $t('sandoz.' + (contract.status.match(/[A-Z][a-z]+/g) ? contract.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase() : contract.status.toLowerCase().replace(/\s+/g, '_'))) }}
                </span>
                <a :href="getContractLink(contract)" target="_blank" class="ml-1"><fa icon="arrow-right"/></a>
              </div>
            </b-col>
          </b-row>
          <hr v-if="linkContracts.length > 0">

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.kuko_wholesaler_information')" v-if="item.kuko_type == 'condition'">

          <table class="table table-sm">
            <thead>
              <tr>
                <th class="d-flex">
                  <b-checkbox v-if="!readOnly" @change="wholesalerToggleAll"/>
                  {{$t('sandoz.wholesaler')}}
                </th>
                <th>{{$t('sandoz.email_recipient')}}</th>
                <th v-if="item.status == 'Approved' || item.status == 'Stored'">{{$t('sandoz.notification_sent_at')}}</th>
                <th v-if="item.status == 'Approved' || item.status == 'Stored'">{{$t('sandoz.actions')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(wholesaler, wholesalerIndex) in item.wholesalers" :key="wholesaler.id">
                <td>
                  <label @click.prevent="item.wholesalers.splice(wholesalerIndex, 1)">
                    <input type="checkbox" checked :disabled="readOnly || wholesaler.readonly_notification_sent_at">
                    {{wholesaler.wholesaler.wholesaler}}
                  </label>
                </td>
                <td>
                  {{wholesaler.email_recipient}}
                  <o-inline-edit v-if="!readOnly" v-model="wholesaler.email_recipient" :color="wholesaler.email_recipient ? 'black': 'red'"/>
                </td>
                <td v-if="item.status == 'Approved' || item.status == 'Stored'">
                  <span v-if="wholesaler.readonly_notification_sent_at">
                    {{wholesaler.readonly_notification_sent_at | formatDatetime}}
                  </span>
                  <span v-else>
                    {{$t('sandoz.pending')}}
                  </span>
                </td>
                <td v-if="item.status == 'Approved' || item.status == 'Stored' || debug">
                  <b-btn v-if="wholesaler.wholesaler.excel_attachment" size="sm" @click.prevent="downloadExcel(item.id, wholesaler.wholesaler.id, wholesaler.wholesaler.excel_attachment)">
                    <fa icon="file-excel"/>
                    {{$t('sandoz.download')}} Excel
                  </b-btn>
                  <b-btn size="sm" @click.prevent="downloadPdf(item.id, wholesaler.wholesaler.id, wholesaler.wholesaler.wholesaler)">
                    <fa icon="file-pdf"/>
                    {{$t('sandoz.download')}} PDF
                  </b-btn>
                </td>
              </tr>
              <template v-for="wholesaler in wholesalers">
                <tr :key="wholesaler.wholesaler_id" v-if="!readOnly && item.wholesalers.filter(w => w.wholesaler_id == wholesaler.id).length == 0">
                  <td>
                    <label>
                      <input type="checkbox" @click.prevent="addWholesaler(wholesaler, item)">
                      {{wholesaler.wholesaler}}
                    </label>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.kuko_condition_information')" v-if="item.kuko_type == 'condition' || item.kuko_type == 'chargebacks'">
          <b-row>
            <b-col>
              <b-form-checkbox v-model="item.condition_categories" :disabled="readOnly" value="otcProducts">{{ $t('sandoz.products') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="readOnly" value="specialOrder">{{ $t('sandoz.special_order') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="readOnly" value="materialGroup">{{ $t('sandoz.material_group') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="internalRebateDisabled" value="portfolioRebate">{{ $t('sandoz.portfolio_rebate') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="internalRebateDisabled" value="gxPortfolioRebate">{{ $t('sandoz.gx_portfolio_rebate') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="internalRebateDisabled" value="volumeRebate">{{ $t('sandoz.volume_rebate') }}</b-form-checkbox>
              <b-form-checkbox v-model="item.condition_categories" :disabled="internalRebateDisabled" value="profitCenter">{{ $t('sandoz.profit_center') }}</b-form-checkbox>
            </b-col>
            <b-col cols="4" align-self="center" v-if="item.condition_categories && item.condition_categories.length">
              <o-value-select :readonly="readOnly" :items="pdfProductVisibility" :label="$t('sandoz.pdf_product_visibility')"
                              v-model="item.pdf_product_visibility"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="item.condition_categories.includes('otcProducts')" xl="12">
              <hr>
              <strong>{{$t('sandoz.products')}}</strong>

              <div class="mt-3 d-flex">
                <b-btn variant="primary" v-if="!readOnly" @click.prevent="addProduct">{{$t('sandoz.add_product')}}</b-btn>
                <b-btn variant="primary" v-if="!readOnly" class="ml-1" @click.prevent="addProductByGln">{{$t('sandoz.add_product_by_gln')}}</b-btn>
                <o-attachment :disabled="readOnly" v-model="item.otc_product_attachments"
                              :label="$t('core.attachments')"
                              :save-url="'/api/kukos/attachments/upload'" :delete-url="'/api/kukos/attachments/delete'"
                              :download-url="'/api/kukos/attachments/download/'"
                              type="otc_product_attachments" @action="addOtcAttachment">
                </o-attachment>

                <b-form-checkbox id="productRebates" v-model="item.product_rebates" class="ml-auto" :disabled="readOnly">
                  {{$t('sandoz.use_volume_rebates')}}
                </b-form-checkbox>
              </div>

              <div class="d-flex">
                <table class="table table-sm" v-if="item.condition_products.length > 0">
                  <thead>
                    <tr>
                      <th>{{$t('sandoz.product')}}</th>
                      <th>{{$t('sandoz.gln')}}</th>
                      <th width="130" v-if="!item.product_rebates">{{$t('sandoz.existing_condition')}}</th>
                      <th width="130" v-if="!item.product_rebates">{{$t('sandoz.new_condition')}}</th>
                      <th width="200" v-if="!item.product_rebates">{{$t('sandoz.valid_from')}}</th>
                      <th width="200" v-if="!item.product_rebates">{{$t('sandoz.valid_to')}}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(product, productIndex) in item.condition_products">
                      <tr>
                        <td>{{product.kuko_product.product}}</td>
                        <td :title="product.kuko_product.pharma_code">{{product.kuko_product.gln}}</td>
                        <td width="130" v-if="!item.product_rebates">
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="product.existing_condition" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td width="130" v-if="!item.product_rebates">
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="product.new_condition" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td width="200" v-if="!item.product_rebates">
                          <o-datepicker-control v-model="product.valid_from" :disabled="readOnly" :readonly="readOnly"
                                                @input-changed="isConditionOutsideYear(
                                                  'otcProducts',
                                                  product.valid_from,
                                                  product.valid_to,
                                                  productIndex
                                                )"/>
                        </td>
                        <td width="200" v-if="!item.product_rebates">
                          <o-datepicker-control v-model="product.valid_to" :disabled="readOnly" :readonly="readOnly"
                                                @input-changed="isConditionOutsideYear(
                                                  'otcProducts',
                                                  product.valid_from,
                                                  product.valid_to,
                                                  productIndex
                                                )"/>
                        </td>
                        <td class="text-right">
                          <o-delete :small="true" v-if="!readOnly" v-on:execute-action="item.condition_products.splice(productIndex, 1); loadProductKpis()"></o-delete>
                        </td>
                      </tr>
                      <tr v-if="!item.product_rebates && conditionOutSideErrors['otcProducts'] && conditionOutSideErrors['otcProducts'].includes(productIndex)">
                        <td colspan="4" class="border-top-0"></td>
                        <td colspan="2" class="text-center border-top-0">
                          <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                        </td>
                        <td class="border-top-0"></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <table class="w-50" v-else>
                  <tr>
                    <td>{{$t('sandoz.please_add_products')}}</td>
                  </tr>
                </table>

                <div class="table-arrow-left" v-if="item.product_rebates">
                  <div class="p-1">
                    <o-form-group :label="$t('sandoz.valid_from')">
                      <o-datepicker-control v-model="item.product_rebate_valid_from" :readonly="readOnly" :disabled="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'otcProducts',
                                              item.product_rebate_valid_from,
                                              item.product_rebate_valid_to
                                            )"/>
                    </o-form-group>
                    <o-form-group :label="$t('sandoz.valid_to')">
                      <o-datepicker-control v-model="item.product_rebate_valid_to" :readonly="readOnly" :disabled="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'otcProducts',
                                              item.product_rebate_valid_from,
                                              item.product_rebate_valid_to
                                            )"/>
                    </o-form-group>
                    <o-form-group :label="''" v-if="conditionOutSideErrors['otcProducts'] && conditionOutSideErrors['otcProducts'].includes(-1)">
                      <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                    </o-form-group>
                  </div>
                  <table class="table table-sm">
                    <thead>
                      <th>{{$t('sandoz.min_quantity')}}</th>
                      <th>{{$t('sandoz.rebate')}}</th>
                      <th class="text-right">
                        <b-btn variant="primary" @click.prevent="item.condition_product_rebates.push({min_quantity: null, rebate: null})" v-if="!readOnly && (item && item.condition_product_rebates && item.condition_product_rebates.length < 5)">
                          <fa icon="plus"></fa>
                        </b-btn>
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="(conditionProductRebate, conditionProductRebateIndex) in item.condition_product_rebates" :key="conditionProductRebate.id">
                        <td>
                          <o-input-mask-control mask="#####" v-model="conditionProductRebate.min_quantity" :readonly="readOnly"/>
                        </td>
                        <td>
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="conditionProductRebate.rebate" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td class="text-right">
                          <o-delete :small="true" v-if="!readOnly" v-on:execute-action="item.condition_product_rebates.splice(conditionProductRebateIndex, 1)"></o-delete>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
            <b-col v-if="item.condition_categories.includes('specialOrder')" xl="12">
              <hr>
              <strong>{{$t('sandoz.special_order')}}</strong>

              <div class="mt-3 d-flex">
                <b-btn variant="primary" v-if="!readOnly" @click.prevent="addSpecialProduct">{{$t('sandoz.add_product')}}</b-btn>
                <b-btn variant="primary" v-if="!readOnly" class="ml-1" @click.prevent="addSpecialProductByGln">{{$t('sandoz.add_product_by_gln')}}</b-btn>
                <o-attachment :disabled="readOnly" v-model="item.special_order_attachments"
                              :label="$t('core.attachments')"
                              :save-url="'/api/kukos/attachments/upload'"
                              :delete-url="'/api/kukos/attachments/delete'"
                              :download-url="'/api/kukos/attachments/download/'"
                              type="special_order_attachments" @action="addSpecialOrderAttachment">
                </o-attachment>

                <span class="ml-auto mr-3" :class="{'text-danger': specialOrderTotal < 500}">CHF {{Math.round(specialOrderTotal*100)/100 | formatNumber}}</span>

                <b-form-checkbox id="specialProductRebates" v-model="item.special_product_rebates" :disabled="readOnly">
                  {{$t('sandoz.use_volume_rebates')}}
                </b-form-checkbox>
              </div>

              <div class="d-flex">
                <table class="table table-sm" v-if="item && item.condition_special_products && item.condition_special_products.length > 0">
                  <thead>
                    <tr>
                      <th>{{$t('sandoz.product')}}</th>
                      <th>{{$t('sandoz.gln')}}</th>
                      <th>{{$t('sandoz.efp')}}</th>
                      <th width="110">{{$t('sandoz.quantity')}}</th>
                      <th width="130" v-if="!item.special_product_rebates">{{$t('sandoz.existing_condition')}}</th>
                      <th width="130" v-if="!item.special_product_rebates">{{$t('sandoz.new_condition')}}</th>
                      <th width="200" v-if="!item.special_product_rebates">{{$t('sandoz.valid_from')}}</th>
                      <th width="200" v-if="!item.special_product_rebates">{{$t('sandoz.valid_to')}}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(product, productIndex) in item.condition_special_products">
                      <tr>
                        <td>{{product.kuko_product.product}}</td>
                        <td :title="product.kuko_product.pharma_code">{{product.kuko_product.gln}}</td>
                        <td>{{product.efp}}</td>
                        <td width="110">
                          <o-input-control v-model="product.quantity" type="number" :readonly="readOnly" :min="1" :apply-range="true" :step="1" :max="999999"/>
                        </td>
                        <td width="130" v-if="!item.special_product_rebates">
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="product.existing_condition" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td width="130" v-if="!item.special_product_rebates">
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="product.new_condition" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td width="200" v-if="!item.special_product_rebates">
                          <o-datepicker-control v-model="product.valid_from" :disabled="readOnly" :readonly="readOnly"
                                                @input-changed="isConditionOutsideYear(
                                                  'specialOrder',
                                                  product.valid_from,
                                                  product.valid_to,
                                                  productIndex
                                                )"/>
                        </td>
                        <td width="200" v-if="!item.special_product_rebates">
                          <o-datepicker-control v-model="product.valid_to" :disabled="readOnly" :readonly="readOnly"
                                                @input-changed="isConditionOutsideYear(
                                                  'specialOrder',
                                                  product.valid_from,
                                                  product.valid_to,
                                                  productIndex
                                                )"/>
                        </td>
                        <td class="text-right">
                          <o-delete v-if="!readOnly" :small="true" v-on:execute-action="item.condition_special_products.splice(productIndex, 1); loadProductKpis()"></o-delete>
                        </td>
                      </tr>
                      <tr v-if="!item.special_product_rebates && conditionOutSideErrors['specialOrder'] && conditionOutSideErrors['specialOrder'].includes(productIndex)">
                        <td colspan="6" class="border-top-0"></td>
                        <td colspan="2" class="text-center border-top-0">
                          <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                        </td>
                        <td class="border-top-0"></td>
                      </tr>
                    </template>
                  </tbody>
                </table>

                <table class="w-50" v-else>
                  <tr>
                    <td>{{$t('sandoz.please_add_products')}}</td>
                  </tr>
                </table>

                <div class="table-arrow-left" v-if="item.special_product_rebates">
                  <div class="p-1">
                    <o-form-group :label="$t('sandoz.valid_from')">
                      <o-datepicker-control v-model="item.special_product_rebate_valid_from" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'specialOrder',
                                              item.special_product_rebate_valid_from,
                                              item.special_product_rebate_valid_to
                                            )"/>
                    </o-form-group>
                    <o-form-group :label="$t('sandoz.valid_to')">
                      <o-datepicker-control v-model="item.special_product_rebate_valid_to" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'specialOrder',
                                              item.special_product_rebate_valid_from,
                                              item.special_product_rebate_valid_to
                                            )"/>
                    </o-form-group>
                    <o-form-group :label="''" v-if="conditionOutSideErrors['specialOrder'] && conditionOutSideErrors['specialOrder'].includes(-1)">
                      <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                    </o-form-group>
                  </div>

                  <table class="table table-sm">
                    <thead>
                      <th>{{$t('sandoz.min_quantity')}}</th>
                      <th>{{$t('sandoz.rebate')}}</th>
                      <th class="text-right">
                        <b-btn variant="primary" @click.prevent="item.condition_special_product_rebates.push({min_quantity: null, rebate: null})" v-if="!readOnly && (item && item.condition_special_product_rebates && item.condition_special_product_rebates.length < 5)">
                          <fa icon="plus"></fa>
                        </b-btn>
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="(conditionProductRebate, conditionProductRebateIndex) in item.condition_special_product_rebates" :key="conditionProductRebate.id">
                        <td>
                          <o-input-mask-control mask="#####" v-model="conditionProductRebate.min_quantity" :readonly="readOnly"/>
                        </td>
                        <td>
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="conditionProductRebate.rebate" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td class="text-right">
                          <o-delete v-if="!readOnly" :small="true" v-on:execute-action="item.condition_special_product_rebates.splice(conditionProductRebateIndex, 1)"></o-delete>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
            <b-col v-if="item.condition_categories.includes('materialGroup')" xl="12">
              <hr>
              <strong>{{$t('sandoz.material_group')}}</strong>

              <div class="mt-3 d-flex">
                <b-form-checkbox id="productGroupRebates" v-model="item.product_group_rebates" class="ml-auto" :disabled="readOnly">
                  {{$t('sandoz.use_volume_rebates')}}
                </b-form-checkbox>
              </div>

              <div class="d-flex">
                <div>
                  <table class="table table-sm" v-if="item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'normal').length > 0">
                    <thead>
                      <tr>
                        <th>{{$t('sandoz.product_group')}}</th>
                        <th width="130" v-if="!item.product_group_rebates">{{$t('sandoz.existing_condition')}}</th>
                        <th width="130" v-if="!item.product_group_rebates">{{$t('sandoz.new_condition')}}</th>
                        <th width="200" v-if="!item.product_group_rebates">{{$t('sandoz.valid_from')}}</th>
                        <th width="200" v-if="!item.product_group_rebates">{{$t('sandoz.valid_to')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(productGroup, productGroupIndex) in item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'normal')">
                        <tr>
                          <td>
                            <label @click.prevent="item.condition_product_groups.splice(filterConditionProductGroup(productGroup.product_group_id), 1)">
                              <input type="checkbox" checked>
                              <span v-html="productGroup.kuko_product_group.description_scheme"></span>
                            </label>
                          </td>
                          <td width="130" v-if="!item.product_group_rebates">
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="productGroup.existing_condition" :readonly="readOnly"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                          </td>
                          <td width="130" v-if="!item.product_group_rebates">
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="productGroup.new_condition" :readonly="readOnly"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                          </td>
                          <td width="200" v-if="!item.product_group_rebates">
                            <o-datepicker-control v-model="productGroup.valid_from" :disabled="readOnly" :readonly="readOnly"
                                                  @input-changed="isConditionOutsideYear(
                                                  'materialGroup',
                                                  productGroup.valid_from,
                                                  productGroup.valid_to,
                                                  productGroupIndex
                                                )"/>
                          </td>
                          <td width="200" v-if="!item.product_group_rebates">
                            <o-datepicker-control v-model="productGroup.valid_to" :disabled="readOnly" :readonly="readOnly"
                                                  @input-changed="isConditionOutsideYear(
                                                  'materialGroup',
                                                  productGroup.valid_from,
                                                  productGroup.valid_to,
                                                  productGroupIndex
                                                )"/>
                          </td>
                        </tr>
                        <tr v-if="!item.product_group_rebates && conditionOutSideErrors['materialGroup'] && conditionOutSideErrors['materialGroup'].includes(productGroupIndex)">
                          <td colspan="3" class="border-top-0"></td>
                          <td colspan="2" class="text-center border-top-0">
                            <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <table class="table table-sm" v-if="!readOnly">
                    <tbody>
                      <template v-for="(productGroup, productGroupIndex) in productGroups">
                        <tr :key="productGroup.id" v-if="productGroup.product_group_category === 'normal' && item.condition_product_groups.filter(w => w.product_group_id == productGroup.id).length == 0">
                          <td>
                            <label>
                              <input type="checkbox" @click="productGroup.warning ? $bvModal.show('modal-warning-2-' + productGroupIndex): addProductGroup(productGroup, item)">
                              <span v-html="productGroup.description_scheme"></span>
                            </label>
                            <b-modal hide-header-close header-text-variant="danger" :title="$t('sandoz.warning')" :id="'modal-warning-2-' + productGroupIndex" @ok="addProductGroup(productGroup, item)">
                              <div v-if="productGroup" v-html="productGroup.warning"></div>
                            </b-modal>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="table-arrow-left" v-if="item.product_group_rebates">
                  <div class="p-1">
                    <o-form-group :label="$t('sandoz.valid_from')">
                      <o-datepicker-control v-model="item.product_group_rebate_valid_from" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'materialGroup',
                                              item.product_group_rebate_valid_from,
                                              item.product_group_rebate_valid_to
                                            )"/>
                    </o-form-group>
                    <o-form-group :label="$t('sandoz.valid_to')">
                      <o-datepicker-control v-model="item.product_group_rebate_valid_to" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'materialGroup',
                                              item.product_group_rebate_valid_from,
                                              item.product_group_rebate_valid_to
                                            )"/>
                    </o-form-group>
                    <o-form-group :label="''" v-if="conditionOutSideErrors['materialGroup'] && conditionOutSideErrors['materialGroup'].includes(-1)">
                      <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                    </o-form-group>
                  </div>
                  <table class="table table-sm" v-if="item.product_group_rebates">
                    <thead>
                      <th>{{$t('sandoz.min_quantity')}}</th>
                      <th>{{$t('sandoz.rebate')}}</th>
                      <th class="text-right">
                        <b-btn variant="primary" v-if="!readOnly && (item && item.condition_product_group_rebates && item.condition_product_group_rebates.length < 5)" @click.prevent="item.condition_product_group_rebates.push({min_quantity: null, rebate: null})">
                          <fa icon="plus"></fa>
                        </b-btn>
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="(conditionProductRebate, conditionProductRebateIndex) in item.condition_product_group_rebates" :key="conditionProductRebate.id">
                        <td>
                          <o-input-mask-control mask="#####" v-model="conditionProductRebate.min_quantity" :readonly="readOnly"/>
                        </td>
                        <td>
                          <b-input-group append="%">
                            <o-input-percentage-control v-model.number="conditionProductRebate.rebate" :readonly="readOnly"
                                                        :min="0.01" :max="99.99" :only-integer="false">
                            </o-input-percentage-control>
                          </b-input-group>
                        </td>
                        <td class="text-right">
                          <o-delete v-if="!readOnly" :small="true" v-on:execute-action="item.condition_product_group_rebates.splice(conditionProductRebateIndex, 1)"></o-delete>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
            <b-col v-if="item.condition_categories.includes('portfolioRebate')" xl="12">
              <hr>
              <strong>{{$t('sandoz.portfolio_rebate')}}</strong>

              <table class="table table-sm mt-3">
                <thead>
                  <tr>
                    <th width="130">{{$t('sandoz.existing_condition')}}</th>
                    <th width="130">{{$t('sandoz.new_condition')}}</th>
                    <th width="200">{{$t('sandoz.valid_from')}}</th>
                    <th width="200">{{$t('sandoz.valid_to')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="130">
                      <b-input-group append="%">
                        <o-input-percentage-control v-model.number="item.portfolio_rebate_existing_condition" :readonly="readOnly"
                                                    :min="0.01" :max="99.99" :only-integer="false">
                        </o-input-percentage-control>
                      </b-input-group>
                    </td>
                    <td width="130">
                      <b-input-group append="%">
                        <o-input-percentage-control v-model.number="item.portfolio_rebate_new_condition" :readonly="readOnly"
                                                    :min="0.01" :max="99.99" :only-integer="false">
                        </o-input-percentage-control>
                      </b-input-group>
                    </td>
                    <td width="200">
                      <o-datepicker-control v-model="item.portfolio_rebate_valid_from" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'portfolioRebate',
                                              item.portfolio_rebate_valid_from,
                                              item.portfolio_rebate_valid_to
                                            )"/>
                    </td>
                    <td width="200">
                      <o-datepicker-control v-model="item.portfolio_rebate_valid_to" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'portfolioRebate',
                                              item.portfolio_rebate_valid_from,
                                              item.portfolio_rebate_valid_to
                                            )"/>
                    </td>
                  </tr>
                  <tr v-if="conditionOutSideErrors['portfolioRebate'] && conditionOutSideErrors['portfolioRebate'].includes(-1)">
                    <td colspan="2" class="border-top-0"></td>
                    <td colspan="2" class="text-center border-top-0">
                      <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col v-if="item.condition_categories.includes('gxPortfolioRebate')" xl="12">
              <hr>
              <strong>{{$t('sandoz.gx_portfolio_rebate')}}</strong>

              <table class="table table-sm mt-3">
                <thead>
                <tr>
                  <th width="130">{{$t('sandoz.existing_condition')}}</th>
                  <th width="130">{{$t('sandoz.new_condition')}}</th>
                  <th width="200">{{$t('sandoz.valid_from')}}</th>
                  <th width="200">{{$t('sandoz.valid_to')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td width="130">
                    <b-input-group append="%">
                      <o-input-percentage-control v-model.number="item.gx_portfolio_rebate_existing_condition" :readonly="readOnly"
                                                  :min="0.01" :max="99.99" :only-integer="false">
                      </o-input-percentage-control>
                    </b-input-group>
                  </td>
                  <td width="130">
                    <b-input-group append="%">
                      <o-input-percentage-control v-model.number="item.gx_portfolio_rebate_new_condition" :readonly="readOnly"
                                                  :min="0.01" :max="99.99" :only-integer="false">
                      </o-input-percentage-control>
                    </b-input-group>
                  </td>
                  <td width="200">
                    <o-datepicker-control v-model="item.gx_portfolio_rebate_valid_from" :disabled="readOnly" :readonly="readOnly"
                                          @input-changed="isConditionOutsideYear(
                                              'gxPortfolioRebate',
                                              item.gx_portfolio_rebate_valid_from,
                                              item.gx_portfolio_rebate_valid_to
                                            )"/>
                  </td>
                  <td width="200">
                    <o-datepicker-control v-model="item.gx_portfolio_rebate_valid_to" :disabled="readOnly" :readonly="readOnly"
                                          @input-changed="isConditionOutsideYear(
                                              'gxPortfolioRebate',
                                              item.gx_portfolio_rebate_valid_from,
                                              item.gx_portfolio_rebate_valid_to
                                            )"/>
                  </td>
                </tr>
                <tr v-if="conditionOutSideErrors['gxPortfolioRebate'] && conditionOutSideErrors['gxPortfolioRebate'].includes(-1)">
                  <td colspan="2" class="border-top-0"></td>
                  <td colspan="2" class="text-center border-top-0">
                    <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col v-if="item.condition_categories.includes('volumeRebate')" xl="12">
              <hr>
              <strong>{{$t('sandoz.volume_rebate')}}</strong>

              <table class="table table-sm mt-3">
                <thead>
                  <tr>
                    <th width="130">{{$t('sandoz.existing_condition')}}</th>
                    <th width="130">{{$t('sandoz.new_condition')}}</th>
                    <th width="200">{{$t('sandoz.valid_from')}}</th>
                    <th width="200">{{$t('sandoz.valid_to')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="130">
                      <b-input-group append="%">
                        <o-input-percentage-control v-model.number="item.volume_rebate_existing_condition" :readonly="readOnly"
                                                    :min="0.01" :max="99.99" :only-integer="false">
                        </o-input-percentage-control>
                      </b-input-group>
                    </td>
                    <td width="130">
                      <b-input-group append="%">
                        <o-input-percentage-control v-model.number="item.volume_rebate_new_condition" :readonly="readOnly"
                                                    :min="0.01" :max="99.99" :only-integer="false">
                        </o-input-percentage-control>
                      </b-input-group>
                    </td>
                    <td width="200">
                      <o-datepicker-control v-model="item.volume_rebate_valid_from" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'volumeRebate',
                                              item.volume_rebate_valid_from,
                                              item.volume_rebate_valid_to
                                            )"/>
                    </td>
                    <td width="200">
                      <o-datepicker-control v-model="item.volume_rebate_valid_to" :disabled="readOnly" :readonly="readOnly"
                                            @input-changed="isConditionOutsideYear(
                                              'volumeRebate',
                                              item.volume_rebate_valid_from,
                                              item.volume_rebate_valid_to
                                            )"/>
                    </td>
                  </tr>
                  <tr v-if="conditionOutSideErrors['volumeRebate'] && conditionOutSideErrors['volumeRebate'].includes(-1)">
                    <td colspan="2" class="border-top-0"></td>
                    <td colspan="2" class="text-center border-top-0">
                      <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
            <b-col v-if="item.condition_categories.includes('profitCenter')" xl="12">
              <hr>
              <strong>{{$t('sandoz.profit_center')}}</strong>

              <div class="d-flex mt-3">
                <div>
                  <table class="table table-sm" v-if="item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'chargeback').length > 0">
                    <thead>
                      <tr>
                        <th>{{$t('sandoz.product_group')}}</th>
                        <th width="130">{{$t('sandoz.new_condition')}}</th>
                        <th width="200">{{$t('sandoz.valid_from')}}</th>
                        <th width="200">{{$t('sandoz.valid_to')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(productGroup, productGroupIndex) in item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'chargeback')">
                        <tr>
                          <td>
                            <label @click.prevent="item.condition_product_groups.splice(filterConditionProductGroup(productGroup.product_group_id), 1)">
                              <input type="checkbox" checked>
                              <span v-html="productGroup.kuko_product_group.description_scheme"></span>
                            </label>
                          </td>
                          <td width="130">
                            <b-input-group append="%">
                              <o-input-percentage-control v-model.number="productGroup.new_condition" :readonly="readOnly"
                                                          :min="0.01" :max="99.99" :only-integer="false">
                              </o-input-percentage-control>
                            </b-input-group>
                          </td>
                          <td width="200">
                            <o-datepicker-control v-model="productGroup.valid_from" :disabled="readOnly" :readonly="readOnly"
                                                  @input-changed="isConditionOutsideYear(
                                                    'profitCenter',
                                                    productGroup.valid_from,
                                                    productGroup.valid_to,
                                                    productGroupIndex
                                                  )"/>
                          </td>
                          <td width="200">
                            <o-datepicker-control v-model="productGroup.valid_to" :disabled="readOnly" :readonly="readOnly"
                                                  @input-changed="isConditionOutsideYear(
                                                    'profitCenter',
                                                    productGroup.valid_from,
                                                    productGroup.valid_to,
                                                    productGroupIndex
                                                  )"/>
                          </td>
                        </tr>
                        <tr v-if="conditionOutSideErrors['profitCenter'] && conditionOutSideErrors['profitCenter'].includes(productGroupIndex)">
                          <td colspan="2" class="border-top-0"></td>
                          <td colspan="2" class="text-center border-top-0">
                            <span class="text-danger">{{ $t('sandoz.kuko_outside_year_warning')}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>

                  <table class="table table-sm" v-if="!readOnly">
                    <tbody>
                      <template v-for="productGroup in productGroups">
                        <tr :key="productGroup.id" v-if="productGroup.product_group_category === 'chargeback' && item.condition_product_groups.filter(w => w.product_group_id == productGroup.id).length == 0">
                          <td>
                            <label>
                              <input type="checkbox" @click.prevent="addProductGroup(productGroup, item)">
                              <span v-html="productGroup.description_scheme"></span>
                            </label>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="mt-3">
            <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
            <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
          </div>
        </b-tab>
        <b-tab :title="$t('sandoz.kuko_additional_information')">
          <b-row>
            <b-col>
              <template v-if="item.kuko_type == 'payment_terms'">
                <template v-if="item">
                  <o-value-select :readonly="readOnly" :items="paymentTerms" :label="$t('sandoz.payment_terms')" v-model="item.payment_terms"/>
                </template>

                <div v-if="item.payment_terms != 'C130 Payable within 30 days net'">
                  <div class="text-danger" v-if="!item.payment_terms_note">{{$t('sandoz.payment_terms_note_required')}}</div>
                  <o-textarea :readonly="readOnly" :label="$t('sandoz.payment_terms_note')" v-model="item.payment_terms_note"/>
                </div>
              </template>
              <o-textarea :readonly="readOnly" :label="$t('sandoz.additional_comments')" v-model="item.comments"/>
            </b-col>
            <b-col>
              <o-input v-if="item.kuko_type == 'condition' && item.account_category != 'smart_selection'" :readonly="readOnly" :label="$t('sandoz.expected_discount')" v-model="item.discount_lower_100" prepend="CHF"/>
              <div v-if="item.discount_lower_100 < 100 && item.discount_lower_100 > 0">
                <div class="text-danger" v-if="!item.expected_discount_note">{{$t('sandoz.expected_discount_note_required')}}</div>
                <o-textarea :readonly="readOnly" :label="$t('sandoz.expected_discount_note')" v-model="item.discount_lower_100_note"/>
              </div>
            </b-col>
          </b-row>

          <div class="mt-3">
            <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
            <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
          </div>
        </b-tab>
        <b-tab :title="$t('sandoz.files')">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th colspan="5" class="pdfFiles">{{ $t('sandoz.user_files') }}</th>
              </tr>
              <tr>
                  <th class="col-sm-1">{{$t('core.id')}}</th>
                  <th class="col-sm-5">{{$t('sandoz.file_name')}}</th>
                  <th class="col-sm-2">{{$t('sandoz.user')}}</th>
                  <th class="col-sm-2">{{$t('sandoz.date')}}</th>
                  <th class="col-sm text-right">
                      <b-form-file  class="d-none" v-model="wordfile" ref="fileinput" @change="addToWordFiles" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain></b-form-file>
                      <b-btn @click.prevent="addFile()" variant="primary">
                        <fa icon="plus"/>
                      </b-btn>
                  </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(file, i) in item.files">
                <td>{{file.id}}</td>
                <td>
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <o-button type="button" variant="primary" @click.prevent="word(i)">
                      <fa :icon="getExtension(file.file_name.name)"/>
                    </o-button>
                  </div>
                  {{file.file_name ? file.file_name.name: null}}
                </td>
                <td>{{file.user ? file.user.name: null}}</td>
                <td>{{file.created_at | formatDate}}</td>
                <td class="text-right text-nowrap">
                  <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                    <b-btn @click.prevent="deleteWordFile(file.id, i)"
                            variant="secondary">
                      <fa icon="times"/>
                    </b-btn>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
        </b-tab>
      </b-tabs>
    </o-card>

    <address-search ref="addressSearch" :contract-type="item.account_category === 'individual_account' ? 'icepeak' : 'kam'" @address-selected="addressSelected"></address-search>
    <kuko-product-search ref="kukoProductSearch" @product-selected="productSelected"></kuko-product-search>

    <b-modal ref="errorModal" ok-only :title="$t('sandoz.errors')">
      <ul>
        <li v-for="validationError in validationErrors" :key="validationError">
          {{validationError}}
        </li>
      </ul>
    </b-modal>
    <o-card v-if="legacyKukos && legacyKukos.length > 0" class="mt-3">
      <b-row>
        <b-col>
          <strong>{{$t('sandoz.legacy_kukos')}}</strong>

          <table class="table table-sm mt-3">
            <thead>
            <tr>
              <th>{{$t('sandoz.kuko_type')}}</th>
              <th>{{$t('sandoz.account_category')}}</th>
              <th>{{$t('sandoz.request_date')}}</th>
              <th>{{$t('sandoz.status')}}</th>
              <th>{{$t('sandoz.requestor')}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="kuko in legacyKukos">
              <td>
                <span v-if="kuko.kuko_type == 'condition'">
                    {{$t('sandoz.conditions')}}
                  </span>
                <span v-if="kuko.kuko_type == 'payment_terms'">
                    {{$t('sandoz.payment_terms')}}
                  </span>
                <span v-if="kuko.kuko_type == 'chargebacks'">
                  {{$t('sandoz.chargebacks')}}
                </span>
              </td>
              <td>
                {{ kuko.account_category ? $t('sandoz.' + kuko.account_category) : null}}
              </td>
              <td>
                {{ kuko.kuko_date | formatDate }}
              </td>
              <td>
                <span v-if="kuko.legacy_kuko" class="badge badge-info">{{$t('sandoz.legacy')}}</span>
                <template v-else>
                  <template v-if="kuko.status">
                      <span v-if="kuko.status == 'Feedback' || kuko.status == 'Rejected'" class="text-danger">
                        {{ $t('sandoz.' + kuko.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
                        <fa icon="info-circle" @click.prevent="showFeedback(props.item)"></fa>
                      </span>
                    <span v-else>
                        {{ $t('sandoz.' + kuko.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
                      </span>
                  </template>
                </template>
              </td>
              <td>
                {{kuko.name}}
              </td>
              <td>
                <a href="javascript:void(0)" @click="gotoKuko(kuko.id)">
                  {{kuko.id}}
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </o-card>
    <o-card v-if="kpis && kpis.length > 0" class="mt-3">
      <b-row>
        <b-col>
          <strong>{{$t('sandoz.kpis')}}</strong>
          <table class="table table-sm mt-3">
            <thead>
            <tr>
              <th>{{$t('sandoz.gross_sales_py')}}</th>
              <th>{{$t('sandoz.gross_sales_cy')}}</th>
              <th>{{$t('sandoz.rebate_py')}}</th>
              <th>{{$t('sandoz.rebate_cy')}}</th>
              <th>{{$t('sandoz.rebate_percentage_py')}}</th>
              <th>{{$t('sandoz.rebate_percentage_cy')}}</th>
              <th>{{$t('sandoz.net_sales_py')}}</th>
              <th>{{$t('sandoz.net_sales_cy')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="kpi in kpis">
              <td>
                {{kpi.gross_sales_py | formatInteger}}
              </td>
              <td>
                {{kpi.gross_sales_cy | formatInteger}}
              </td>
              <td>
                {{ kpi.rebate_py | formatInteger }}
              </td>
              <td>
                {{kpi.rebate_cy | formatInteger}}
              </td>
              <td>
                {{kpi.rebate_percentage_py * 100 }}%
              </td>
              <td>
                {{kpi.rebate_percentage_cy * 100 }}%
              </td>
              <td>
                {{kpi.net_sales_py | formatInteger }}
              </td>
              <td>
                {{kpi.net_sales_cy | formatInteger }}
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </o-card>
    <o-card v-if="productKpis && productKpis.length > 0" class="mt-3">
      <b-row>
        <b-col>
          <strong>{{$t('sandoz.product_kpis')}}</strong>
          <table class="table table-sm mt-3">
            <thead>
            <tr>
              <th>{{$t('sandoz.gross_sales_py')}}</th>
              <th>{{$t('sandoz.gross_sales_cy')}}</th>
              <th>{{$t('sandoz.rebate_py')}}</th>
              <th>{{$t('sandoz.rebate_cy')}}</th>
              <th>{{$t('sandoz.rebate_percentage_py')}}</th>
              <th>{{$t('sandoz.rebate_percentage_cy')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="kpi in productKpis">
              <td>
                {{kpi.gross_sales_py | formatInteger}}
              </td>
              <td>
                {{kpi.gross_sales_cy | formatInteger}}
              </td>
              <td>
                {{ kpi.rebate_py | formatInteger}}
              </td>
              <td>
                {{kpi.rebate_cy | formatInteger}}
              </td>
              <td>
                {{kpi.rebate_percentage_py * 100}}%
              </td>
              <td>
                {{kpi.rebate_percentage_cy * 100}}%
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </o-card>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button variant="outline-primary" @click.prevent="back">{{$t('sandoz.back_to_archive')}}</o-button>
        <o-button v-if="item.id && item.status && item.status != 'Cancelled' && item.status != 'Draft'" variant="danger" class="ml-2" :loading="saving" @click.prevent="cancelKuko">{{$t('sandoz.cancel_kuko')}}</o-button>
        <div class="ml-auto">
          <span class="badge badge-danger mr-3" v-if="item.status === 'Contract Approval Pending'">{{ $t('sandoz.waiting_for_contract_approval') }}</span>
          <o-data-history v-if="item.id" class="mr-2" type="App\Models\Sandoz\Kuko" :id="item.id"></o-data-history>
          <o-button v-if="item.status == 'Draft'" variant="primary" :loading="saving" @click.prevent="saveAndApprove">{{$t('sandoz.save_and_approve')}}</o-button>
          <o-button v-if="item.status == 'Feedback'" variant="primary" :loading="saving" @click.prevent="saveAndContinueApprove">{{$t('sandoz.save_and_continue_approve')}}</o-button>

          <o-button v-if="item.status == 'Draft'" variant="primary" :loading="saving" @click.prevent="save">{{$t('sandoz.save_draft')}}</o-button>
          <o-button v-if="item.status == 'Feedback'" variant="primary" :loading="saving" @click.prevent="save">{{$t('core.save')}}</o-button>
        </div>
      </div>
    </o-action-toolbar>

    <b-modal ref="cancelModal" :title="$t('sandoz.cancel_kuko')" @ok="confirmCancelKuko" @hidden="cancelInformCS = true" ok-variant="danger" :ok-title="$t('core.yes')" :cancel-title="$t('core.no')">
      <p>{{ $t('sandoz.cancel_kuko_inform_cs_text') || 'We should inform customer service so that they can amend the conditions in SAP.' }}</p>
      <b-form-checkbox v-model="cancelInformCS">
        {{ $t('sandoz.cancel_kuko_inform_cs_checkbox') || 'Inform customer service to remove the conditions in SAP' }}
      </b-form-checkbox>
    </b-modal>
  </form>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import AddressSearch from '../sandoz/partials/AddressSearch.vue'
  import AddressSelection from './partials/KukoAddressSelection.vue'
  import KukoProductSearch from './partials/KukoProductSearch.vue'
  import { getDefaultStartDate, getDefaultEndDate, contractYears, getCurrentYear } from '../../utils/contractYear'
  import qs from 'qs'
  var moment = require('moment-timezone')

  export default {
    data: () => ({
      loaded: false,
      validationErrors: [],
      saving: false,
      cancelInformCS: true,
      trueValue: true,
      wholesalers: [],
      productGroups: [],
      maximumCustomers: 50,
      activeTab: 0,
      item: {
        external_id: null,
        user_id: null,
        condition_categories: [],
        condition_product_groups: [],
        account_category: '',
        wholesalers: [],
        customer_external_id:null,
        contracts: [],
        new_opening: null
      },
      addressSelectionDimensions: [],
      kukoProductSearchMode: '',
      paymentTerms: [
        {value: 'C130 Payable within 30 days net', text: 'C130 Payable within 30 days net'},
        {value: 'C160 Payable within 60 days net', text: 'C160 Payable within 60 days net'},
        {value: 'C190 Payable within 90 days net', text: 'C190 Payable within 90 days net'}
      ],
      legacyKukos: [],
      kpis: [],
      productKpis: [],
      eanForKpis: [],
      years: [],
      linkContracts:[],
      refContract: [],
      wordfile : null,
      conditionGroups: [],
      loadedApprovalSteps: [],
      buyingGroupWarning: null,
      pdfProductVisibility: [],
      defaultApprovers : [],
      conditionOutSideErrors: {
        otcProducts: [],
        specialOrder: [],
        materialGroup: [],
        portfolioRebate: [],
        gxPortfolioRebate: [],
        volumeRebate: [],
        profitCenter: []
      }
    }),
    components: {
      AddressSearch,
      KukoProductSearch,
      AddressSelection
    },
    created() {
      this.addressSelectionDimensions.push({
        dimension: 'buying_group',
        label: this.$i18n.t('sandoz.buying_group')
      })
      this.addressSelectionDimensions.push({
        dimension: 'zip_code',
        label: this.$i18n.t('sandoz.zip_code')
      })
      this.addressSelectionDimensions.push({
        dimension: 'channel',
        label: this.$i18n.t('sandoz.channel')
      })
      this.addressSelectionDimensions.push({
        dimension: 'sub_channel',
        label: this.$i18n.t('sandoz.sub_channel')
      })
      this.addressSelectionDimensions.push({
        dimension: 'language',
        label: this.$i18n.t('sandoz.language')
      })
      this.addressSelectionDimensions.push({
        dimension: 'wholesaler',
        label: this.$i18n.t('sandoz.wholesaler')
      })
      this.addressSelectionDimensions.push({
        dimension: 'pharmacy_classification',
        label: this.$i18n.t('sandoz.pharmacy_classification')
      })

      this.years = contractYears()

      this.pdfProductVisibility = [
        { value: 'hide', text: this.$i18n.t('sandoz.hide_pdf_product') },
        { value: 'preview', text: this.$i18n.t('sandoz.preview_product') },
        { value: 'full', text: this.$i18n.t('sandoz.full_product_list') },
      ]
    },
    mounted() {
      this.getDefaultApprovers()
      this.getConditionGroups()
      this.loadData()
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      }),
      debug() {
        return 'debug' in this.$route.query
      },
      isNew() {
        return !('id' in this.item)
      },
      previousKukoExists() {
        if (!this.legacyKukos) return false
        return this.legacyKukos.filter(k => k.id != this.item.id).length > 0
      },
      hasConditionValidForThreeMonths() {
        let dates = []
        if (this.item.condition_categories) {
          if (this.item.condition_categories.includes('otcProducts')) {
            if (this.item.product_rebates) {
              dates.push({from: this.item.product_rebate_valid_from, to: this.item.product_rebate_valid_to})
            } else if (this.item.condition_products) {
              this.item.condition_products.forEach(p => dates.push({from: p.valid_from, to: p.valid_to}))
            }
          }
          if (this.item.condition_categories.includes('specialOrder')) {
            if (this.item.special_product_rebates) {
              dates.push({from: this.item.special_product_rebate_valid_from, to: this.item.special_product_rebate_valid_to})
            } else if (this.item.condition_special_products) {
              this.item.condition_special_products.forEach(p => dates.push({from: p.valid_from, to: p.valid_to}))
            }
          }
          if (this.item.condition_categories.includes('materialGroup') || this.item.condition_categories.includes('profitCenter')) {
            if (this.item.product_group_rebates) {
              dates.push({from: this.item.product_group_rebate_valid_from, to: this.item.product_group_rebate_valid_to})
            } else if (this.item.condition_product_groups) {
              this.item.condition_product_groups.forEach(p => dates.push({from: p.valid_from, to: p.valid_to}))
            }
          }
          if (this.item.condition_categories.includes('portfolioRebate')) {
            dates.push({from: this.item.portfolio_rebate_valid_from, to: this.item.portfolio_rebate_valid_to})
          }
          if (this.item.condition_categories.includes('gxPortfolioRebate')) {
            dates.push({from: this.item.gx_portfolio_rebate_valid_from, to: this.item.gx_portfolio_rebate_valid_to})
          }
          if (this.item.condition_categories.includes('volumeRebate')) {
            dates.push({from: this.item.volume_rebate_valid_from, to: this.item.volume_rebate_valid_to})
          }
        }
        
        let validDates = dates.filter(d => d.from && d.to)
        if (validDates.length === 0) return true // Fallback so it doesn't mistakenly require the field if no dates are provided
        
        for (let d of validDates) {
          let from = moment(d.from, 'YYYY-MM-DD')
          let to = moment(d.to, 'YYYY-MM-DD')
          if (to.diff(from, 'months', true) >= 3) {
            return true
          }
        }
        
        return false
      },
      isNewOpeningRequired() {
        return !this.hasConditionValidForThreeMonths && !this.previousKukoExists
      },
      statusLabel() {
        if (this.item.legacy_kuko) {
          return this.$i18n.t('sandoz.legacy')
        }
        if (!this.item.status) {
          return ''
        }
        const parts = this.item.status.match(/[A-Z][a-z]+/g)
        if (!parts) {
          return this.item.status
        }
        return this.$i18n.t('sandoz.' + parts.join('_').toLowerCase())
      },
      internalRebateDisabled() {
        if (this.readOnly) {
          return true
        }
        /*
        // we already have it enabled, useful for existing KUKOs that were created wrongly
        if (this.item.condition_categories.includes('portfolioRebate') || this.item.condition_categories.includes('volumeRebate')) {
          return false
        }
        // We only allow alloga, as long as we have multiple wholesalers selected, it's not allowed
        if (this.item.wholesalers.length != 1) {
          return true
        }
        // not alloga, disable it
        if (this.item.wholesalers[0].wholesaler.wholesaler != 'Alloga AG') {
          return true
        }
        */
        // enabled
        return false
      },
      filteredCustomers() {
        return this.item.customers.filter((a,i) => i < this.maximumCustomers)
      },
      readOnly() {
        if (!this.item) {
          return true
        }
        if (this.item.status == 'Draft' || this.item.status == 'Feedback') {
          return false
        }
        return true
      },
      approvalDisabled() {
        if (this.item.account_category === 'individual_account' || this.item.account_category === 'buying_group') {
          return !(this.item.contracts && this.item.contracts.length) && !(this.item.files && this.item.files.length > 0)
        }
        return false
      },
      specialOrderTotal() {
        if (!this.item.condition_categories.includes('specialOrder')) {
          return null
        }
        if (!this.item.condition_special_products) {
          return null
        }
        if (!this.item.special_product_rebates) {
          return this.item.condition_special_products.reduce((a,b) => a + b.efp * b.quantity * ((100 - (b.new_condition * 100)) / 100), 0)
        }
        else {
          var self = this

          var totalQuantity = this.item.condition_special_products.reduce((a,b) => {
            return a + new Number(b.quantity)
          }, 0)

          var rebate = 0
          if (self.item && self.item.condition_special_product_rebates) {
            var rebateRecord = self.item.condition_special_product_rebates.filter(q => q.min_quantity <= totalQuantity).sort((a,b) => b.min_quantity - a.min_quantity)
            if (rebateRecord.length > 0) {
              rebate = rebateRecord[0].rebate * 100
            }
          }

          return this.item.condition_special_products.reduce((a,b) => {

            return a + b.efp * b.quantity * ((100 - rebate) / 100)
          }, 0)
        }
      },
      filteredLinkContracts() {
        if (!this.linkContracts) return []
        if (this.readOnly) {
          return this.linkContracts.filter(c => this.isContractLinked(c))
        }
        return this.linkContracts
      }
    },
    methods: {
      back() {
        if (this.$route.path == this.$router.history._startLocation) {
          this.$router.push({name: 'sandoz.kuko.list'})
        } else {
          this.$router.back()
        }
      },
      setRefData () {
        if (!document.location.search) {
          return
        }
        var params = qs.parse(document.location.search.substr(1))

        this.$nextTick(() => {
          let kukoType = params.type
          if (kukoType) {
            if (kukoType.includes('APO')) kukoType = 'APO'
            else if (kukoType.includes('IMMUNO')) kukoType = 'IMMUNO'
            else if (kukoType.includes('SD')) kukoType = 'SD'
            else if (kukoType.includes('CNS')) kukoType = 'CNS'
            else if (kukoType.includes('ONCO')) kukoType = 'ONCO'
            else if (kukoType.includes('HOSP')) kukoType = 'HOSP'
            else kukoType = kukoType.replace('_KUKO', '')
          }

          this.item.channel = kukoType
          this.item.kuko_year = params.year
          this.item.account_category = 'individual_account'
          this.item.external_id = params.external_id
          this.item.sap_id = params.sap_id
          this.item.account_sub_type = params.sub_type
          this.item.primary_parent = params.primary
          this.item.address1 = params.company
          this.item.address2 = params.street
          this.item.address3 = params.city

          this.loadLinkContracts(this.item.external_id, this.item.kuko_year)
        })
      },
      wholesalerToggleAll(val) {
        if (!val) {
          this.item.wholesalers = []
        }
        else {
          this.item.wholesalers = this.wholesalers.map(w => {
            return {
              wholesaler_id: w.id,
              email_recipient: w.kuko_recipient,
              wholesaler: w
            }
          })
        }
      },
      searchCustomers(items) {
        axios.post('/api/kukos/smart-selection', items).then(response => {
          this.item.customers = response.data
        })
      },
      downloadExcel(kukoId, wholesalerId, attachmentType) {
        axios.get(`/api/kukos/${kukoId}/wholesalers/${wholesalerId}/excel`, { responseType: 'arraybuffer' }).then(response => {
          require('downloadjs')(response.data,
            attachmentType + '_' + kukoId + '_' + moment.utc(this.item.kuko_date).format('YYYYMMDD') + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          )
        })
      },
      downloadPdf(kukoId, wholesalerId, wholesalerName) {
        axios.get(`/api/kukos/${kukoId}/wholesalers/${wholesalerId}/pdf`, { responseType: 'arraybuffer' }).then(response => {
          require('downloadjs')(response.data,
            'kuko_' + kukoId + '_' + moment.utc(this.item.kuko_date).format('YYYYMMDD') + '_' + wholesalerName +  '.pdf', 'application/pdf'
          )
        })
      },
      buyingGroupSelected(item) {
        if (!item) {
          this.loadLinkContracts(null, this.item.kuko_year)
          return
        }

        this.item.address1 = item.buying_group
        this.buyingGroupWarning = item.kuko_warning
        
        // Trigger loadLinkContracts with the newly selected buying group code
        // wrapped in $nextTick to ensure v-model has finished updating item.external_id
        this.$nextTick(() => {
          this.loadLinkContracts(this.item.external_id, this.item.kuko_year)
        })
      },
      conditionGroupSelected() {
        if(this.item.external_id) {
          var filterGroup = this.conditionGroups.filter(c => c.value === this.item.external_id)
          if(filterGroup && Object.keys(filterGroup).length > 0) {
            this.item.address1 = filterGroup[0].text
          }
        } else {
            this.item.address1 = null
            this.item.external_id = null
        }
      },
      saveAndContinueApprove() {
        this.saveAndApproveInternal(false)
      },
      saveAndApprove() {
        this.saveAndApproveInternal(true)
      },
      validateForm() {
        var errors = []
        if (!this.item.account_category) {
          errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.account_category')}))
        } else {
          switch (this.item.account_category) {
            case 'individual_account':
              if (!this.item.external_id) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.customer_external_id')}))
              }
              if (this.isNewOpeningRequired && this.item.new_opening == null || this.item.new_opening === '') {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.new_opening')}) + ' (' + this.$t('sandoz.kuko_customer_information') + ')')
              }
              break
            case 'buying_group':
              if (!this.item.external_id) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.buying_group')}))
              }
              break
            // case 'chargeback_condition':
            //   if (!this.item.external_id) {
            //     errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.kuko_conditions')}))
            //   }
            //   break
            case 'smart_selection':
              if (this.item.customers.length == 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.customers')}))
              }
              break
          }
        }
        if (this.item.wholesalers.length == 0 && this.item.kuko_type == 'condition') {
          errors.push(this.$t('sandoz.please_select_wholesaler'))
        }
        if (!this.item.channel) {
          errors.push(this.$t('sandoz.please_select_approver'))
        }
        if (this.item.condition_categories.length == 0 && (this.item.kuko_type == 'condition' || this.item.kuko_type == 'chargebacks')) {
          errors.push(this.$t('sandoz.please_select_condition_category'))
        }
        if (this.item.condition_categories.includes('otcProducts')) {
          if (this.item.condition_products.length == 0) {
            errors.push(this.$t('sandoz.please_select_one_otc_product'))
          }
          else {
            if (!this.item.product_rebates) {
              if (this.item.condition_products.filter(c => !c.new_condition).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.new_condition')}))
              }
              if (this.item.condition_products.filter(c => !c.valid_from).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (this.item.condition_products.filter(c => !c.valid_to).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
            }
            else {
              if (!this.item.product_rebate_valid_from) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (!this.item.product_rebate_valid_to) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
              if (this.item.condition_product_rebates.length == 0) {
                errors.push(this.$t('sandoz.please_define_volume_rebate'))
              }
              else {
                if (this.item.condition_product_rebates.filter(c => !c.rebate).length > 0) {
                  errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.rebate')}))
                }
                if (this.item.condition_product_rebates.filter(c => !c.min_quantity).length > 0) {
                  errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.min_quantity')}))
                }
              }
            }
          }
        }
        if (this.item.condition_categories.includes('specialOrder')) {
          if (this.specialOrderTotal < 500) {
            errors.push(this.$t('sandoz.special_order_sum_too_low'))
          }
          if (this.item.condition_special_products.length == 0) {
            errors.push(this.$t('sandoz.please_select_one_special_product'))
          }
          else {
            if (!this.item.special_product_rebates) {
              if (this.item.condition_special_products.filter(c => !c.new_condition).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.new_condition')}))
              }
              if (this.item.condition_special_products.filter(c => !c.quantity).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.quantity')}))
              }
              if (this.item.condition_special_products.filter(c => !c.valid_from).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (this.item.condition_special_products.filter(c => !c.valid_to).length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
            }
            else {
              if (!this.item.special_product_rebate_valid_from) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (!this.item.special_product_rebate_valid_to) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
              if (this.item.condition_special_product_rebates.length == 0) {
                errors.push(this.$t('sandoz.please_define_volume_rebate'))
              }
              else {
                if (this.item.condition_special_product_rebates.filter(c => !c.rebate).length > 0) {
                  errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.rebate')}))
                }
                if (this.item.condition_special_product_rebates.filter(c => !c.min_quantity).length > 0) {
                  errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.min_quantity')}))
                }
              }
            }
          }
        }
        if (this.item.condition_categories.includes('materialGroup')) {
          if (this.item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'normal').length == 0) {
            errors.push(this.$t('sandoz.please_select_one_product_group'))
          }
          else {
            if (!this.item.product_group_rebates) {
              if (this.item.condition_product_groups.filter(c => !c.new_condition && c.kuko_product_group.product_group_category === 'normal').length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.new_condition')}))
              }
              if (this.item.condition_product_groups.filter(c => !c.valid_from && c.kuko_product_group.product_group_category === 'normal').length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (this.item.condition_product_groups.filter(c => !c.valid_to && c.kuko_product_group.product_group_category === 'normal').length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
            }
            else {
              if (!this.item.product_group_rebate_valid_from) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (!this.item.product_group_rebate_valid_to) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
              if (this.item.condition_product_group_rebates.length == 0) {
                errors.push(this.$t('sandoz.please_define_volume_rebate'))
              }
              else {
                if (this.item.condition_product_group_rebates.filter(c => !c.rebate).length > 0) {
                  errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.rebate')}))
                }
                if (this.item.condition_product_group_rebates.filter(c => !c.min_quantity).length > 0) {
                  errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.min_quantity')}))
                }
              }
            }
          }
        }

        if (this.item.condition_categories.includes('profitCenter')) {
          if (this.item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'chargeback').length == 0) {
            errors.push(this.$t('sandoz.please_select_one_profit_center'))
          }
          else {
            if (!this.item.product_group_rebates) {
              if (this.item.condition_product_groups.filter(c => !c.new_condition && c.kuko_product_group.product_group_category === 'chargeback').length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.new_condition')}))
              }
              if (this.item.condition_product_groups.filter(c => !c.valid_from && c.kuko_product_group.product_group_category === 'chargeback').length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_from')}))
              }
              if (this.item.condition_product_groups.filter(c => !c.valid_to && c.kuko_product_group.product_group_category === 'chargeback').length > 0) {
                errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.valid_to')}))
              }
            }
          }
        }
        if (this.item.kuko_type == 'condition' && this.item.account_category != 'smart_selection') {
          if (!this.item.discount_lower_100) {
            errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.expected_discount')}))
          }
          else {
            if (this.item.discount_lower_100 < 100 && !this.item.discount_lower_100_note) {
              errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.expected_discount_note')}))
            }
          }
        }
        if (this.item.kuko_type == 'payment_terms' && this.item.payment_terms != 'C130 Payable within 30 days net' && !this.item.payment_terms_note) {
          errors.push(this.$t('sandoz.missing_value', {'field': this.$t('sandoz.payment_terms_note')}))
        }

        const hasAnyError = Object.values(this.conditionOutSideErrors)
          .some(arr => Array.isArray(arr) && arr.length > 0)

        if (hasAnyError) {
          errors.push(this.$t('sandoz.kuko_outside_year_warning')+' '+this.$t('sandoz.kuko_condition_information'))
        }
        
          this.item.approval_steps.forEach(step => {
            const approvers = step.users
              .filter(u => u.enabled && u.user && (this.item.status !== 'Draft' || u.user.active))
              .filter(u => !u.is_deputy);

            // If no approvers exist
            if (!approvers.length) {
              errors.push(this.$i18n.t('sandoz.allowed_approver_not_found', {approval_role: step.approval_role}))
              this.$notify({
                title: this.$i18n.t('sandoz.allowed_approver_not_found', {approval_role: step.approval_role}),
              })
            }
          });
        
        return errors
      },
      saveAndApproveInternal(validate) {
        if (validate) {
          this.validationErrors = this.validateForm()
          if (this.validationErrors.length > 0) {
            this.$refs.errorModal.show()
            return
          }
        }

        this.item.status = 'Committed'
        this.item.approval_feedback = ''
        this.save()

        this.$notify({
          title: this.$i18n.t('sandoz.kuko_approval_started'),
          text: this.$i18n.t('sandoz.kuko_approval_started_text')
        })
        this.$router.push({name: 'sandoz.kuko.list'})
      },
      save() {
        var url = this.url
        var route = this.$route

        // this happens if we create a new data record and update it right away without navigating way. We'll still have
        // new in our url, but we don't want to create a new record, we want to update the record we just created.
        // @TODO we should do this in a more elegant way that doesn't require search & replace
        if (url.indexOf('/new') > 0 && 'id' in this.item) {
          url = url.replace('/new', '/' + this.item.id)
        }

        var root = this.$root
        var self = this

        this.saving = true

        axios
          .post(url, this.item)
          .then((response) => {
            this.item = response.data

            // assign our new id to the route params in case someone wants to work with it
            if ('id' in response.data) {
              route.params.id = response.data.id
            }

            this.loadedApprovalSteps = this.item.approval_steps
            this.$notify({
              title: this.$i18n.t('core.saved'),
              text: this.$i18n.t('core.saved_text')
            })

            // remove all error states
            var elements = document.querySelectorAll('.has-error')
            elements.forEach((element) => {
              element.classList.remove('has-error')
            })

            // clear all errors
            root.errors = {}

            // stop loading indicator
            self.saving = false
          })
          .catch((error) => {
            // stop loading indicator
            self.saving = false

            if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
              this.$notify({
                title: this.$i18n.t('core.validation_error'),
                text: this.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                type: 'error'
              })
              if ('data' in error.response && 'errors' in error.response.data) {
                root.errors = error.response.data.errors
              }
            } else {
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error_text', {url: this.url}),
                type: 'error'
              })
            }
          })
      },
      cancelKuko() {
        this.$refs.cancelModal.show()
      },
      confirmCancelKuko() {
        this.saving = true
        axios.post(`/api/kukos/${this.item.id}/cancel`, { inform_cs: this.cancelInformCS }).then(response => {
          this.saving = false
          this.$notify({title: this.$i18n.t('core.success'), text: this.$i18n.t('core.success_text'), type: 'success'})
          this.loadData()
        }).catch(error => {
          this.saving = false
          this.$notify({title: this.$i18n.t('core.error'), text: this.$i18n.t('core.error_text'), type: 'error'})
        })
      },
      setIndividualAddress() {
        this.addressMode = 'individualAddress'
        this.$refs.addressSearch.showAddressSearchModal(this)
      },
      addSpecialProduct() {
        this.kukoProductSearchMode = 'condition_special_products'
        this.$refs.kukoProductSearch.showProductSearchModal(this)
      },
      addProduct() {
        this.kukoProductSearchMode = 'condition_products'
        this.$refs.kukoProductSearch.showProductSearchModal(this)
      },
      addSpecialProductByGln() {
        this.addProductByGlnInternal('condition_special_products')
      },
      addProductByGln() {
        this.addProductByGlnInternal('condition_products')
      },
      addProductByGlnInternal(target) {
        var gln = window.prompt(this.$i18n.t('sandoz.gln_prompt'))
        if (!gln) {
          return
        }
        axios.get(`/api/kuko_products?filter[gln]=${gln}`).then(response => {
          var products = response.data.data
          if (products.length == 0) {
            window.alert(this.$i18n.t('sandoz.invalid_gln'))
          }
          else {
            this.item[target].push(
              {
                product_id: products[0].id,
                kuko_product: products[0],
                existing_condition: null,
                new_condition: null,
                valid_from: getDefaultStartDate(),
                valid_to: getDefaultEndDate(),
                efp: products[0].efp
              }
            )
          }
          this.loadProductKpis()
        })
      },
      productSelected(productEvent) {
        let product = productEvent.product
        let owningComponent = productEvent.owningComponent
        let owningComponentData = owningComponent.$data

        owningComponentData.item[owningComponentData.kukoProductSearchMode].push(
          {
            product_id: product.id,
            kuko_product: product,
            existing_condition: null,
            new_condition: null,
            valid_from: getDefaultStartDate(),
            valid_to: getDefaultEndDate(),
            efp: product.efp
          }
        )
        this.loadProductKpis()
      },
      addressSelected(addressEvent) {
        let address = addressEvent.address
        let owningComponent = addressEvent.owningComponent
        let owningComponentData = owningComponent.$data

        owningComponentData.item.external_id = address.org_external_id
        owningComponentData.item.sap_id = address.org_sap_id
        owningComponentData.item.account_sub_type = address.org_sub_type
        owningComponentData.item.primary_parent = address.parent_full_name
        owningComponentData.item.address1 = address.org_full_name
        owningComponentData.item.address2 = address.org_street
        owningComponentData.item.address3 = address.org_zip_code + " " + address.org_city

        this.loadLegacy(owningComponentData.item.external_id)
        this.loadKpis(owningComponentData.item.external_id)
        this.loadLinkContracts(owningComponentData.item.external_id, this.item.kuko_year)
      },
      loadData() {
        this.loadKuko()
        this.loadWholesalers()
        this.loadProductGroups()
      },
      loadWholesalers() {
        axios.get(`/api/wholesalers?per_page=999&sortBy=wholesaler`).then(response => {
          this.wholesalers = response.data.data
        })
      },
      loadProductGroups() {
        axios.get(`/api/kuko_product_groups?per_page=999`).then(response => {
          this.productGroups = response.data.data
        })
      },
      enableWatchers() {
        this.$watch('item.kuko_type', (newVal) => {
          if (newVal == 'payment_terms') {
            this.item.account_category = 'individual_account'
          }
        })
        this.$watch('item.kuko_year', (newVal) => {
          this.loadLinkContracts(this.item.external_id, newVal)
        })
        this.$watch('item.channel', (newVal) => {
          this.filterApprovers(newVal)
          this.loadLinkContracts(this.item.external_id, this.item.kuko_year)
        })

        this.$watch('item.account_category', (newVal) => {
          this.filterApprovers(this.item.channel)
        })
      },
      loadKuko() {
        this.url = `/api/kukos/${this.$route.params.id}?include=user,approval_feedback_user,wholesalers,wholesalers.wholesaler,condition_product_groups,condition_product_groups.kuko_product_group,condition_products,condition_products.kuko_product,condition_special_products,condition_special_products.kuko_product,condition_product_rebates,condition_product_group_rebates,condition_special_product_rebates,approval_steps,approval_steps.users,approval_steps.users.user,approval_steps.user,otc_product_attachments,special_order_attachments,customers,files.user,contracts`
        axios
          .get(this.url)
          .then((response) => {
            var item = response
            if (this.dataKey) {
              item = response[this.dataKey]
            }
            this.item = item.data

            // set default user
            if (!this.item.user_id) {
              this.item.user_id = this.user.id
            }

            // set default year
            if (this.item.kuko_year == null || this.$route.params.id === 'new') {
              this.$set(this.item, 'kuko_year', getCurrentYear())
            }

            this.loadedApprovalSteps = this.item.approval_steps
            this.loadLegacy(this.item.external_id)
            this.loadKpis(this.item.external_id)
            this.loadProductKpis()
            this.loadLinkContracts(this.item.external_id, this.item.kuko_year)

            // filter chargable condition product groups
            this.$nextTick(() => {
              this.loaded = true

              if(this.item.account_category === "chargeback_condition") {
                this.conditionGroupSelected()
              }

              this.enableWatchers()
              this.setRefData()
              this.filterApprovers(this.item.channel)
            })
          })
      },
      loadLegacy(newVal) {
        if(typeof newVal === 'undefined' || !newVal) {
          return
        }

        axios
          .get(`/api/kukos/legacy/${newVal}`)
          .then((response) => {
            this.legacyKukos = response.data
          })
      },
      loadKpis(newVal) {
        if(typeof newVal === 'undefined' || !newVal) {
          return
        }

        axios
          .get(`/api/kukos/kpis/${newVal}`)
          .then((response) => {
            this.kpis = response.data
          })
      },
      loadProductKpis() {
        var _self = this
        _self.eanForKpis = []
        if(_self.item.condition_products && _self.item.condition_products.length > 0) {
          _self.item.condition_products.forEach(function (product) {
            if(product.kuko_product.gln && !_self.eanForKpis.includes(product.kuko_product.gln)) {
              _self.eanForKpis.push(product.kuko_product.gln)
            }
          })
        }

        if(_self.item.condition_special_products && _self.item.condition_special_products.length > 0) {
          _self.item.condition_special_products.forEach(function (product) {
            if(product.kuko_product.gln && !_self.eanForKpis.includes(product.kuko_product.gln)) {
              _self.eanForKpis.push(product.kuko_product.gln)
            }
          })
        }

        axios
          .post(`/api/kukos/product_kpis`, {code: _self.eanForKpis})
          .then((response) => {
            this.productKpis = response.data
          })
      },
      addWholesaler(wholesaler, item) {
        this.item.wholesalers.push({wholesaler_id: wholesaler.id, email_recipient: wholesaler.kuko_recipient, wholesaler: wholesaler})
      },
      addProductGroup(productGroup, item) {
        this.item.condition_product_groups.push(
          {
            product_group_id: productGroup.id,
            kuko_product_group: productGroup,
            existing_condition: null,
            new_condition: null,
            valid_from: getDefaultStartDate(),
            valid_to: getDefaultEndDate()
          }
        )
      },
      addOtcAttachment (files) {
        const _self = this
        files.forEach(function (file) {
          _self.item.otc_product_attachments.push(
            {
              deleted_at: null,
              file: file.servername,
              kuko_id: _self.$route.params.id
            }
          )
        })
      },
      addSpecialOrderAttachment (files) {
        const _self = this
        files.forEach(function (file) {
          _self.item.special_order_attachments.push(
            {
              deleted_at: null,
              file: file.servername,
              kuko_id: _self.$route.params.id
            }
          )
        })
      },
      gotoKuko (id) {
        const route = this.$router.resolve({ path: '/kukos/' + id })
        window.open(route.href)
      },
      isContractLinked(contract) {
        return !!(this.item.contracts && this.item.contracts.some(c => c.id == contract.id))
      },
      toggleContractLink(contract, checked) {
        if (!this.item.contracts) {
          this.$set(this.item, 'contracts', [])
        }
        if (checked) {
          if (!this.item.contracts.some(c => c.id == contract.id)) {
            this.item.contracts.push({ id: contract.id })
          }
        } else {
          this.item.contracts = this.item.contracts.filter(c => c.id != contract.id)
        }
      },
      loadLinkContracts(externalID, kukoYear) {
        if(typeof externalID === 'undefined' || !externalID || typeof kukoYear === 'undefined' || !kukoYear || !this.item.channel) {
          this.linkContracts = []
          return
        }

        if (this.item.id && this.item.id !== 'new') {
          // For existing KUKOs, only display contracts explicitly attached in the DB
          this.linkContracts = this.item.contracts && this.item.contracts.data ? this.item.contracts.data : (this.item.contracts || [])
          return
        }

        let params = { channel: this.item.channel, account_category: this.item.account_category }
        
        // Immediately reset the displayed and selected contracts for a NEW kuko when criteria change.
        // This ensures old selections from a previous year/externalID don't persist while loading or if it fails.
        this.linkContracts = []
        this.$set(this.item, 'contracts', [])

        axios
          .get(`/api/kukos/contracts/${externalID}/${kukoYear}`, { params: params })
          .then((response) => {
            this.linkContracts = response.data
            
            if (!this.item.contracts) {
              this.$set(this.item, 'contracts', [])
            }
            
            // Auto-link all matching contracts ONLY if KUKO is still editable
            if (this.item.status === 'Draft' || this.item.status === 'Feedback') {
              this.linkContracts.forEach(contract => {
                if (!this.item.contracts.some(c => c.id === contract.id)) {
                  this.item.contracts.push({ id: contract.id })
                }
              })
            }
          })
      },
      getContractLink(contract) {
        if (!contract) return ''

        let routeName = 'sandoz.ice_peak.contract_detail'
        const type = contract.type || ''

        if (type.startsWith('KAM') || type.startsWith('BIOS_KAM')) {
          routeName = 'sandoz.kam.contract_detail'
        } else if (type.includes('EDUCATIONAL')) {
          routeName = 'sandoz.educational.contract_detail'
        } else if (type.includes('PV')) {
          routeName = 'sandoz.pv.contract_detail'
        } else if (type.includes('GADGET')) {
          routeName = 'sandoz.gadget.contract_detail'
        } else if (type.includes('APO_ONE')) {
          routeName = 'sandoz.apo_one.contract_detail'
        }

        const route = this.$router.resolve({ name: routeName, params: { id: contract.id } })
        return route.href
      },
      async filterApprovers(channel) {
        var baseSteps = this.loadedApprovalSteps
        // if kuko restart and status feedback at that time update kuko approvers same as draft
        if(this.item.status === 'Draft' || this.checkFeedbackReview(baseSteps)) {
          baseSteps = this.defaultApprovers

          if(Object.keys(baseSteps).length === 0) {
            await this.getDefaultApprovers()
            baseSteps = this.defaultApprovers
          }

          if(channel === 'Market Access' &&
            baseSteps.filter( step => step.approval_role.search('Head of Market Access') > -1 ).length <= 0
          ) {
            await axios
              .get(`/api/kukos/market_access_approval_step`)
              .then((response) => {
                baseSteps.unshift(response.data)
              })
          } else if(channel === 'High Specialty' &&
            baseSteps.filter( step => step.approval_role.search('Marketing') > -1 ).length <= 0
          ) {
            await axios
              .get(`/api/kukos/marketing_access_approval_step`)
              .then((response) => {
                baseSteps.splice(2, 0, response.data);
              })
          } else if(baseSteps.filter( step => step.approval_role.search('Business') > -1 ).length <= 0) {
            await axios
              .get(`/api/kukos/business_approval_step`)
              .then((response) => {
                baseSteps.unshift(response.data)
              })
          }

          if(channel === 'High Specialty') {
            baseSteps.forEach(item => {
              if(item.sort_order >= 3 && item.approval_role !== 'Marketing') {
                item.sort_order++;
              }
            });
          } else {
            baseSteps.forEach((item, idx) => {
              if(item.sort_order >= 3 && item.approval_role !== 'Marketing') {
                item.sort_order = idx + 1;
              }
            });
          }
          
          const uniq = (arr, track = new Set()) => arr.filter(({ approval_role }) => (track.has(approval_role) ? false : track.add(approval_role)));
          baseSteps = uniq(baseSteps)

          this.defaultApprovers = baseSteps.filter(function (step) {
            if(channel === 'Market Access' && (step.approval_role === 'Business')) {
              return false
            }

            if(channel !== 'High Specialty' && (step.approval_role === 'Marketing')) {
              return false
            }
            return !(channel !== 'Market Access' && step.approval_role === 'Head of Market Access');
          })

          var accountCategoryUser = this.getBusinessRoleBasedOnAccountCategory()
          this.defaultApprovers.sort(function(a, b){return a.sort_order - b.sort_order}).forEach(a => {
            a.users.forEach(u => {
              // users where the role isn't connected to a channel/type are left untouched
              if (u.approval_role_type) {
                if(this.item.region_id != null && a.approval_role === "Business") {
                  if(accountCategoryUser != null && a.approval_role === "Business") {
                    u.enabled = (channel == u.approval_role_type || channel === null) && (u.region_id === this.item.region_id || u.region_id === null ) && accountCategoryUser === u.approval_role
                  } else {
                    u.enabled = (channel == u.approval_role_type || channel === null) && (u.region_id === this.item.region_id || u.region_id === null )
                  }
                } else {

                  if(accountCategoryUser != null && a.approval_role === "Business") {
                    u.enabled = (channel == u.approval_role_type || channel === null) && accountCategoryUser === u.approval_role
                  } else {
                    u.enabled = (channel == u.approval_role_type || channel === null)
                  }
                }
                
              } else {
                if(this.item.region_id != null && a.approval_role === "Business") {
                  if(accountCategoryUser != null && a.approval_role === "Business") {
                    u.enabled = (u.region_id === this.item.region_id || u.region_id === null) && accountCategoryUser === u.approval_role
                  } else {
                    u.enabled = u.region_id === this.item.region_id || u.region_id === null
                  }
                } else {
                  if(accountCategoryUser != null && a.approval_role === "Business") {
                    u.enabled = accountCategoryUser === u.approval_role
                  } else {
                    u.enabled = true
                  }
                }
              }
            })


            // a.users = Object.values(
            //   a.users.reduce((acc, item) => {
            //     acc[item.user_id] = item;
            //     return acc;
            //   }, {})
            // );

          })

          this.item.approval_steps = this.defaultApprovers
        } else {

          //   if(channel === 'Market Access' &&
          //   baseSteps.filter( step => step.approval_role.search('Head of Market Access') > -1 ).length <= 0
          // ) {
          //   await axios
          //     .get(`/api/kukos/market_access_approval_step`)
          //     .then((response) => {
          //       baseSteps.unshift(response.data)
          //     })
          // } else if(baseSteps.filter( step => step.approval_role.search('Performance Unit') > -1 ).length <= 0) {
          //   await axios
          //     .get(`/api/kukos/performance_unit_approval_step`)
          //     .then((response) => {
          //       baseSteps.unshift(response.data)
          //     })
          // }

          this.item.approval_steps = baseSteps.filter(function (step) {
            if(channel === 'Market Access' && step.approval_role === 'Performance Unit') {
              return false
            }

            if(channel !== 'High Specialty' && (step.approval_role === 'Marketing')) {
              return false
            }
            return !(channel !== 'Market Access' && step.approval_role === 'Head of Market Access');
          })

          this.item.approval_steps.sort(function(a, b){return a.sort_order - b.sort_order}).forEach(a => {
            a.users.forEach(u => {
              // users where the role isn't connected to a channel/type are left untouched
              // if (u.approval_role_type) {
              //   u.enabled = channel == u.approval_role_type
              // } else
            })
          })
        }
      },
      addToWordFiles(evt) {
        var fileName = evt.target.value.replace(/^.*[\\/]/, '')
        var files = evt.target.files
        var file = files[0]

        if (!file) {
          return
        }

        if (file) {
          var reader = new window.FileReader()
          const self = this
          reader.onload = function (readerEvt) {
            let wordOb = {
              id : self.item.id !== 'new' && self.item.id !== undefined ? null : 'NEW_TEMP_ID_' + (++self.newFileCounter),
              kuko_id : self.item.id,
              user_id: self.user.id,
              user: self.user,
              file_name: {
                data: readerEvt.target.result,
                name: fileName
              }
            }

            if(self.item.id !== 'new'  && self.item.id !== undefined) {
              self.uploadWordFile(wordOb)
            } else {
              self.item.files.push(wordOb);
              self.wordfile = null;
            }
          }
          reader.readAsDataURL(file)
        }
      },
      addFile() {
        this.$refs.fileinput.$refs.input.click()
      },
      word (i) {
      if (i !== null) {
        const file = this.item.files[i]
        axios.post('/api/sandoz/kuko_file/download', {
            'id': file.id
          }, {responseType: 'arraybuffer'})
              .then((response) => {
                require('downloadjs')(
                  response.data,
                  file.file_name.name,
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                )
              }).catch((error) => {
            console.log(error)
          })
        }
      },
      deleteWordFile(id, i) {
        if(this.item.id !== 'new') {

          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          axios.delete(`/api/sandoz/kuko_file/${id}`)
          .then((response) => {
            this.item.files.splice(i, 1)
          }).catch((error) => {
          })
        } else {
          this.item.files.splice(i, 1)
        }
      },
      uploadWordFile(obj) {
        axios.post(`/api/sandoz/kuko_file/new?include=user`,obj)
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          this.item.files.push(response.data);
          this.wordfile = null;
        }).catch((error) => {
        })
      },
      getExtension(fileName) {
        if(fileName !== '') {
          var ext = fileName.split('.').pop()

          if(ext === 'doc' || ext === 'docx') {
            return 'file-word'
          } else if(ext === 'odt' || ext === 'txt') {
            return 'file-text'
          } else if(ext === 'pdf') {
            return 'file-pdf'
          } else if(ext === 'xls' || ext === 'xlsx' || ext === 'ods') {
            return 'file-excel'
          } else if(ext === 'ppt' || ext === 'pptx') {
            return 'file-powerpoint'
          }
          return 'file'
        }
      },
      getConditionGroups() {
        axios
          .get(`/api/kuko_condition_groups?per_page=999`)
          .then((response) => {
              const self = this
              var groupData = response.data.data
              groupData.forEach(function (condition_group) {
                self.conditionGroups.push({value: condition_group.customer_external_id, text: condition_group.condition_group})
              })
          })
      },
      filterConditionProductGroup(productGroupID) {
        var index = null
        for (var i = 0; i <  this.item.condition_product_groups.length; i++) {
            if(this.item.condition_product_groups[i].product_group_id === productGroupID) {
              index = i
              return index
            }
        }
      },
      hasAccountCategory(categoryValue, categoryName) {
        if (!this.item) return false;
        
        // Always show the currently selected category so it doesn't disappear
        if (this.item.account_category === categoryValue) return true;
        
        // Render based on requestor's account categories
        if (this.item.user && Array.isArray(this.item.user.account_categories)) {
           return this.item.user.account_categories.includes(categoryName);
        }
        
        // Fallback for older data without account_categories or missing user
        return true;
      },
      setCurrentUser(user) {
        if (!user) {
          return
        }
        
        this.$set(this.item, 'user', user)
        
        if (user.regions && user.regions.data && Object.keys(user.regions.data).length) {
          this.item.region_id = user.regions.data[0].region_id
        } else {
          this.item.region_id = null
        }

        this.filterApprovers(this.item.channel)
      },
      getBusinessRoleBasedOnAccountCategory() {
        if(this.item.account_category === 'individual_account') {
          return 'Individual KUKO Approver'
        } else if(this.item.account_category === 'buying_group') {
          return 'Buying Group KUKO Approver'
        } else if(this.item.account_category === 'smart_selection') {
          return 'Special Customer KUKO Approver'
        } else if(this.item.account_category === 'chargeback_condition') {
          return 'Chargeback KUKO Approver'
        }

        return null
      },
      getDefaultApprovers() {
        return axios.get(`/api/kukos/default_approval_step`)
        .then((response) => {
          this.defaultApprovers = response.data.default_approvers
        })
      },
      checkFeedbackReview(baseSteps) {
        if(this.item.status === 'Feedback') {
          var steps  = baseSteps.filter(function (step) {
            return step.approved_by_user_id !== null
          })
          if(Object.keys(steps).length === 0) {
            return true
          }
          return false
        }
        return false
      },
      async isConditionOutsideYear(type, from, to, key = -1) {
        const fromYear = from ? moment(from).year() : null
        const toYear = to ? moment(to).year() : null
        const kukoYear = this.item && this.item.kuko_year ? this.item.kuko_year : null

        if ((!kukoYear && fromYear) || (!kukoYear && toYear) || (fromYear && kukoYear != fromYear) || (toYear && kukoYear != toYear)) {
          if (!this.conditionOutSideErrors[type].includes(key)) {
            this.conditionOutSideErrors[type].push(key)
          }
        } else if (this.conditionOutSideErrors[type].includes(key)) {
          const index = this.conditionOutSideErrors[type].indexOf(key);
          if (index > -1) {
            this.conditionOutSideErrors[type].splice(index, 1);
          }
        }
      },
      checkConditionYear() {
        const _self = this
        _self.$nextTick(function () {
          if (_self.item.condition_categories.includes('otcProducts')) {
            if (_self.item.product_rebates) {
              _self.isConditionOutsideYear(
                'otcProducts',
                _self.item.product_rebate_valid_from,
                _self.item.product_rebate_valid_to
              )
            } else {
              if (_self.item.condition_products && _self.item.condition_products.length > 0) {
                _self.item.condition_products.forEach(function (product, productIndex) {
                  _self.isConditionOutsideYear(
                    'otcProducts',
                    product.valid_from,
                    product.valid_to,
                    productIndex
                  )
                })
              }
            }
          }

          if (_self.item.condition_categories.includes('specialOrder')) {
            if (_self.item.special_product_rebates) {
              _self.isConditionOutsideYear(
                'specialOrder',
                _self.item.special_product_rebate_valid_from,
                _self.item.special_product_rebate_valid_to
              )
            } else {
              if (_self.item.condition_special_products && _self.item.condition_special_products.length > 0) {
                _self.item.condition_special_products.forEach(function (product, productIndex) {
                  _self.isConditionOutsideYear(
                    'specialOrder',
                    product.valid_from,
                    product.valid_to,
                    productIndex
                  )
                })
              }
            }
          }

          if (_self.item.condition_categories.includes('materialGroup')) {
            if (_self.item.product_group_rebates) {
              _self.isConditionOutsideYear(
                'materialGroup',
                _self.item.product_group_rebate_valid_from,
                _self.item.product_group_rebate_valid_to
              )
            } else {
              const productsGroup = _self.item.condition_product_groups.filter(w => w.kuko_product_group.product_group_category === 'normal');
              if (productsGroup && productsGroup.length > 0) {
                productsGroup.forEach(function (productGroup, productGroupIndex) {
                  _self.isConditionOutsideYear(
                    'materialGroup',
                    productGroup.valid_from,
                    productGroup.valid_to,
                    productGroupIndex
                  )
                })
              }
            }
          }

          if (_self.item.condition_categories.includes('portfolioRebate')) {
            _self.isConditionOutsideYear(
              'portfolioRebate',
              _self.item.portfolio_rebate_valid_from,
              _self.item.portfolio_rebate_valid_to
            )
          }

          if (_self.item.condition_categories.includes('gxPortfolioRebate')) {
            _self.isConditionOutsideYear(
              'gxPortfolioRebate',
              _self.item.gx_portfolio_rebate_valid_from,
              _self.item.gx_portfolio_rebate_valid_to
            )
          }

          if (_self.item.condition_categories.includes('volumeRebate')) {
            _self.isConditionOutsideYear(
              'volumeRebate',
              _self.item.volume_rebate_valid_from,
              _self.item.volume_rebate_valid_to
            )
          }

          if (_self.item.condition_categories.includes('profitCenter')) {
            const productsGroup = _self.item.condition_product_groups.filter(
              w => w.kuko_product_group.product_group_category === 'chargeback'
            )

            if (productsGroup && productsGroup.length > 0) {
              productsGroup.forEach(function (productGroup, productGroupIndex) {
                _self.isConditionOutsideYear(
                  'profitCenter',
                  productGroup.valid_from,
                  productGroup.valid_to,
                  productGroupIndex
                )
              })
            }
          }
        })
      }
    }
  }
</script>
<style scoped>

.align-category {
  position: relative;
  top: -30px;
  left: 175px;
}

.disabled-look {
  opacity: 0.65;
  cursor: pointer; /* Change to pointer so it feels clickable for the info */
}
</style>
